module.exports = __webpack_public_path__ + "v294910/img/pdf doc.3323ef73.png";